import { render } from "./AppSearchForm.vue?vue&type=template&id=10e75660"
import script from "./AppSearchForm.vue?vue&type=script&lang=js"
export * from "./AppSearchForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__